import styled from 'styled-components';
import { NewApplicationContainer } from '../NewApplicationPage/styled';

export const NewExpertContainer = styled(NewApplicationContainer)``;
